export const DEFAULT_SCORING = {
  passYdsPer: 20, passYdsBonus: 0, passYdsBonusThreshold: 0,
  passTD: 6, passInt: -2, passComp: 0,
  rushYdsPer: 10, rushYdsBonus: 0, rushYdsBonusThreshold: 0,
  rushTD: 6,
  receptions: 0.5, recBonusRB: 0, recBonusWR: 0, recBonusTE: 0,
  recYdsPer: 10, recYdsBonus: 0, recYdsBonusThreshold: 0,
  recTD: 6,
  twoPtConv: 2, fumbles: 0, fumblesLost: -2, returnTD: 6,
  fgMade: 3, fgMade0_19: 3, fgMade20_29: 3, fgMade30_39: 3, fgMade40_49: 4, fgMade50: 5, fgMissed: -1, patMade: 1, patMissed: -1,
  defSack: 1, defInt: 2, defFumRec: 2, defTD: 6, defSafety: 2, defBlockKick: 2,
  defPtsAllowed0: 10, defPtsAllowed1_6: 7, defPtsAllowed7_13: 4,
  defPtsAllowed14_20: 1, defPtsAllowed21_27: 0, defPtsAllowed28_34: -1, defPtsAllowed35: -4,
};

/**
 * House scoring presets, one per platform default.
 *
 * Lives here rather than inside useLeagueSettings because /rate's team tab is a
 * standalone surface with no hook chain and needs the same list: two copies of
 * a scoring preset is how the builder and a funnel page come to grade the same
 * roster differently. The hook still exports it as PLATFORM_DEFAULTS for its
 * existing consumers.
 *
 * `changes` is applied over DEFAULT_SCORING, never used on its own.
 */
export const PLATFORM_PRESETS = [
  { name: "Yahoo Default", label: "Yahoo (0.5 PPR, 1QB)", changes: { receptions: 0.5, passYdsPer: 25, passTD: 4, passInt: -1, rushTD: 6, recTD: 6, fumbles: 0, fumblesLost: -2 } },
  { name: "ESPN Default", label: "ESPN (Full PPR, 1QB)", changes: { receptions: 1, passYdsPer: 25, passTD: 4, passInt: -2, rushTD: 6, recTD: 6, fumbles: 0, fumblesLost: -2 } },
  { name: "Sleeper Default", label: "Sleeper (0.5 PPR, 1QB)", changes: { receptions: 0.5, passYdsPer: 25, passTD: 4, passInt: -2, rushTD: 6, recTD: 6, fumbles: 0, fumblesLost: -2 } },
];

export const STAT_BASELINES = {
  QB: { passYds: 4700, passTD: 35, passInt: 10, rushYds: 500, rushTD: 4, fumbles: 8, fumblesLost: 5 },
  RB: { rushYds: 1400, rushTD: 12, receptions: 55, recYds: 450, recTD: 3, fumbles: 6, fumblesLost: 3 },
  WR: { receptions: 95, recYds: 1400, recTD: 11, rushYds: 30, rushTD: 0, fumbles: 2, fumblesLost: 1 },
  TE: { receptions: 85, recYds: 1000, recTD: 8, fumbles: 2, fumblesLost: 1 },
  K: { fgMade: 35, fgMissed: 2, patMade: 45, patMissed: 2 },
  DEF: { sacks: 45, ints: 16, fumRec: 10, defTD: 3, safeties: 2, blockedKicks: 2, ptsAllowedPerGame: 19 },
};

export const STAT_LABELS = {
  passComp: "Comp", passYds: "Pass Yds", passTD: "Pass TD", passInt: "INT", passBonusGames: "350+ Pass",
  rushAtt: "Att", rushYds: "Rush Yds", rushTD: "Rush TD", rush1D: "Rush 1D", rushBonusGames: "150+ Rush",
  tgt: "Tgt", receptions: "Rec", recYds: "Rec Yds", recTD: "Rec TD", rec1D: "Rec 1D", recBonusGames: "150+ Rec",
  fumbles: "Fum", fumblesLost: "Fum Lost",
  fgMade: "FG Made", fgMissed: "FG Miss", patMade: "PAT Made", patMissed: "PAT Miss",
  sacks: "Sacks", ints: "INT", fumRec: "Fum Rec", defTD: "DEF TD", safeties: "Safety", blockedKicks: "Blk Kick", ptsAllowedPerGame: "Pts/G",
};

export const DEFAULT_SETTINGS = {
  budget: 200,
  teams: 10,
  scoring: { ...DEFAULT_SCORING },
  positions: { QB: 1, RB: 2, WR: 3, TE: 1, FLEX: 1, SFLEX: 0, DEF: 1, K: 1, BN: 6 },
};
